import ArticlePage from './ArticlePage';
import { comparisonArticles } from '@/mocks/articles';

export default function OopbuyComparisonPage() {
  return <ArticlePage data={comparisonArticles.oopbuy} />;
}